import * as React from 'react';
import { getCitiesAsync, getCountiesAsync, getZipcodesAsync } from '../../../../actions/DataActionExtension.g';
// @ts-ignore
import { Secondary } from '@churchofjesuschrist/eden-buttons';
// @ts-ignore
import { Error } from '@churchofjesuschrist/eden-alert';
import { Address } from '@msdyn365-commerce/retail-proxy';

export const PeruCheckout: React.FC<any> = ({
    resources,
    customSetAddress,
    context,
    setIsVisible,
    setIsDisabled,
    filteredItems,
    defaultCountryRegionId,
    currentAddress
}) => {
    const [name, setName] = React.useState<string>('');
    const [streetNum, setStreetNum] = React.useState<string>('');
    const [street, setStreet] = React.useState<string>('');
    const [counties, setCounties] = React.useState<any>();
    const [cities, setCities] = React.useState<any>();
    const [stateId, setStateId] = React.useState<any>('');
    // const [state, setState] = React.useState<any>('');
    const [city, setCity] = React.useState<any>('');
    const [county, setCounty] = React.useState<any>('');
    const [address, setAddress] = React.useState<any>([]);
    const [citySelected, setCitySelected] = React.useState<boolean>(false);
    const [zipcode, setZipcode] = React.useState<any>('');
    // const [, setZipcode] = React.useState<any>('');

    React.useEffect(() => {
        if (name !== '' && street !== '' && citySelected && streetNum !== '' && zipcode !== '') {
            setIsDisabled(false);
        } else {
            setIsDisabled(true);
        }
    }, [address, citySelected]);
    const getData = async (state: string, county: string) => {
        const ctx = { callerContext: context.actionContext };

        const countiesList = await getCountiesAsync(ctx, 'PER', state);

        const citiesList = await getCitiesAsync(ctx, 'PER', state, county);

        setCounties(countiesList);
        setCities(citiesList);
    };

    React.useEffect(() => {
        if (currentAddress && currentAddress.Name && currentAddress.Name !== '') {
            setName(currentAddress.Name);
        }
        if (currentAddress && currentAddress.City && currentAddress.City !== '') {
            setCity(currentAddress.City);
        }
        if (currentAddress && currentAddress.State && currentAddress.State !== '') {
            setStateId(currentAddress.State);
        }
        if (currentAddress && currentAddress.ZipCode && currentAddress.ZipCode !== '') {
            setZipcode(currentAddress.ZipCode);
        }
        if (currentAddress && currentAddress.Street && currentAddress.Street !== '') {
            const streetSplit = currentAddress.Street.split('\n');
            if (streetSplit && streetSplit[0]) {
                setStreet(streetSplit[0]);
            }
            if (streetSplit && streetSplit[1]) {
                setStreetNum(streetSplit[1]);
            }
            if (streetSplit && streetSplit[2]) {
                setCounty(streetSplit[2]);
            }
        }
        // if (currentAddress && currentAddress.DistrictName && currentAddress.DistrictName !== '') {
        //     setNeighborhood(currentAddress.DistrictName);
        // }
        if (currentAddress && currentAddress.StreetNumber && currentAddress.StreetNumber !== '') {
            setStreetNum(currentAddress.StreetNumber);
        }

        if (currentAddress && currentAddress.Street && currentAddress.State) {
            const streetSplit = currentAddress.Street.split('\n');
            if (streetSplit && streetSplit[2]) {
                void getData(currentAddress.State, streetSplit[2]);
            }
        }
        // if (currentAddress && currentAddress.Name && currentAddress.Name !== '') {
        //     setName(currentAddress.Name);
        // }
    }, []);

    let countiesList;
    const findCounties = async (state: any) => {
        const ctx = { callerContext: context.actionContext };
        // countiesList = await getCountiesAsync(ctx, 'PER', state);
        countiesList = await getCountiesAsync(ctx, 'PER', state);
        const selectedState = filteredItems.filter((county: any) => {
            return county.key === state;
        });

        const customAddress: Address = {
            Name: name,
            Street: `${street}\n${streetNum}\n${county}`,
            StreetNumber: streetNum,
            City: city,
            State: selectedState[0].key,
            ZipCode: zipcode
        };
        setCitySelected(false);

        customSetAddress(customAddress);
        setCounties(countiesList);
        setCities([]);
        setStateId(state);
        setAddress(customAddress);

        return countiesList;
    };
    let citiesList: any;
    const findCities = async (county: any) => {
        const ctx = { callerContext: context.actionContext };
        citiesList = await getCitiesAsync(ctx, 'PER', stateId, county);

        setCounty(county);
        setCities(citiesList);

        const customAddress: Address = {
            Name: name,
            Street: `${street}\n${streetNum}\n${county}`,
            StreetNumber: streetNum,
            City: city,
            State: stateId,
            ZipCode: zipcode
        };
        setCitySelected(false);
        customSetAddress(customAddress);
        setCity('');
        setAddress(customAddress);

        return citiesList;
    };
    let zipcodeAsync: any;
    const selectCity = async (city: any) => {
        const ctx = { callerContext: context.actionContext };

        zipcodeAsync = await getZipcodesAsync(ctx, 'PER', stateId, county, city).catch((err: any) => {
            console.log(err);
        });
        if (zipcodeAsync && zipcodeAsync[0]) {
            setZipcode(zipcodeAsync[0].ZipPostalCode);
        }

        const customAddress: Address = {
            Name: name,
            Street: `${street}\n${streetNum}\n${county}`,
            StreetNumber: streetNum,
            City: city,
            State: stateId,
            ZipCode: zipcodeAsync && zipcodeAsync[0] ? zipcodeAsync[0].ZipPostalCode : ''
        };

        customSetAddress(customAddress);
        if (city && city !== '') {
            setCitySelected(true);
        } else {
            setCitySelected(false);
        }
        setAddress(customAddress);
        setCity(city);
    };

    const customSetName = (name: any) => {
        const customAddress: Address = {
            Name: name,
            Street: `${street}\n${streetNum}\n${county}`,
            StreetNumber: streetNum,
            City: city,
            State: stateId,
            ZipCode: zipcode
        };

        customSetAddress(customAddress);
        setAddress(customAddress);
        setName(name);
    };
    const customSetStreetNum = (streetNum: any) => {
        const customAddress: Address = {
            Name: name,
            Street: `${street}\n${streetNum}\n${county}`,
            StreetNumber: streetNum,
            City: city,
            State: stateId,
            ZipCode: zipcode
        };

        customSetAddress(customAddress);
        setAddress(customAddress);
        setStreetNum(streetNum);
    };
    const customSetStreet = (street: any) => {
        const customAddress: Address = {
            Name: name,
            Street: `${street}\n${streetNum}\n${county}`,
            StreetNumber: streetNum,
            City: city,
            State: stateId,
            ZipCode: zipcode
        };
        customSetAddress(customAddress);
        setAddress(customAddress);
        setStreet(street);
    };
    return (
        <div>
            <label
                style={{
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    lineHeight: '19px',
                    marginLeft: '8px'
                }}
            >
                {resources.addressNameLabel}
            </label>
            <input
                type='text'
                name=''
                id=''
                style={{
                    border: '1px solid #878A8C',
                    borderRadius: '2px',
                    boxSizing: 'border-box',
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    lineHeight: '22px',
                    margin: '8px 0px',
                    padding: '8px',
                    width: '100%'
                }}
                value={name}
                onChange={(e: any) => customSetName(e.target.value)}
            />
            <label
                style={{
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    lineHeight: '19px',
                    marginLeft: '8px'
                }}
            >
                {`${resources.addressSectorLabel} *`}
            </label>
            <input
                type='text'
                name=''
                id=''
                style={{
                    border: '1px solid #878A8C',
                    borderRadius: '2px',
                    boxSizing: 'border-box',
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    lineHeight: '22px',
                    margin: '8px 0px',
                    padding: '8px',
                    width: '100%'
                }}
                value={streetNum}
                onChange={(e: any) => customSetStreetNum(e.target.value)}
            />
            <label
                style={{
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    lineHeight: '19px',
                    marginLeft: '8px'
                }}
            >
                {resources.addressStreetLabel1}
            </label>
            <input
                type='text'
                name=''
                id=''
                style={{
                    border: '1px solid #878A8C',
                    borderRadius: '2px',
                    boxSizing: 'border-box',
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    lineHeight: '22px',
                    margin: '8px 0px',
                    padding: '8px',
                    width: '100%'
                }}
                value={street}
                onChange={(e: any) => customSetStreet(e.target.value)}
            />
            <label
                style={{
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    lineHeight: '19px',
                    marginLeft: '8px'
                }}
            >
                {' '}
                {resources.addressRegionNameLabel}
            </label>
            <select
                className='msc-address-form'
                style={{
                    border: '1px solid #878A8C',
                    borderRadius: '2px',
                    boxSizing: 'border-box',
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    lineHeight: '22px',
                    margin: '8px 0px',
                    padding: '8px',
                    width: '100%'
                }}
                name=''
                id=''
                onChange={(e: any) => findCounties(e.target.value)}
            >
                {filteredItems
                    ? filteredItems.map((state: any, index: any) => {
                          if (state.key === '') {
                              return null;
                          } else {
                              return (
                                  <option
                                      value={state.key}
                                      key={state.key}
                                      disabled={state.value === '' ? true : false}
                                      selected={state.value === '' ? true : stateId && stateId === state.key ? true : false}
                                  >
                                      {state.value}
                                  </option>
                              );
                          }
                      })
                    : null}
            </select>
            <label
                style={{
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    lineHeight: '19px',
                    marginLeft: '8px'
                }}
            >
                {' '}
                {resources.addressMunicipalityNameLabel}
            </label>
            <select
                className='msc-address-form'
                style={{
                    border: '1px solid #878A8C',
                    borderRadius: '2px',
                    boxSizing: 'border-box',
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    lineHeight: '22px',
                    margin: '8px 0px',
                    padding: '8px',
                    width: '100%'
                }}
                name=''
                id=''
                onChange={(e: any) => findCities(e.target.value)}
                disabled={counties && counties.length > 0 ? false : true}
            >
                <option value='' selected></option>
                {counties ? (
                    counties.map((state: any, index: any) => {
                        return (
                            <option value={state.CountyId} key={index} selected={county === state.CountyId ? true : false}>
                                {state.Name}
                            </option>
                        );
                    })
                ) : county !== '' ? (
                    <option value={county} selected={county ? true : false}>
                        {county}
                    </option>
                ) : null}
            </select>
            <label
                style={{
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    lineHeight: '19px',
                    marginLeft: '8px'
                }}
            >
                {' '}
                {resources.addressDistrictLabel}
            </label>
            <select
                className='msc-address-form'
                style={{
                    border: '1px solid #878A8C',
                    borderRadius: '2px',
                    boxSizing: 'border-box',
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    lineHeight: '22px',
                    margin: '8px 0px',
                    padding: '8px',
                    width: '100%'
                }}
                name=''
                id=''
                onChange={(e: any) => selectCity(e.target.value)}
                disabled={cities && cities.length > 0 ? false : true}
            >
                <option value='' selected></option>
                {cities ? (
                    cities.map((cityItem: any, index: any) => {
                        return (
                            <option value={cityItem.Name} key={index} selected={city === cityItem.Name ? true : false}>
                                {cityItem.Name}
                            </option>
                        );
                    })
                ) : city !== '' ? (
                    <option value={city} selected={city ? true : false}>
                        {city}
                    </option>
                ) : null}
            </select>
            <label
                style={{
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    lineHeight: '19px',
                    marginLeft: '8px'
                }}
            >
                {' '}
                {resources.addressThreeLetterISORegionNameLabel}
            </label>
            <select
                className='msc-address-form'
                style={{
                    border: '1px solid #878A8C',
                    borderRadius: '2px',
                    boxSizing: 'border-box',
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    lineHeight: '22px',
                    margin: '8px 0px',
                    padding: '8px',
                    width: '100%'
                }}
                name=''
                id=''
                disabled={true}
            >
                <option value='' disabled selected>
                    {defaultCountryRegionId}
                </option>
            </select>
        </div>
    );
};
